/**
 * axios setup to use mock service
 */

import axios from 'axios';
import { environment } from 'environments/environment';
import axiosRetry from 'axios-retry';

const axiosServices = axios.create({ baseURL: environment.apiBaseUrl });
// axiosRetry(axios, {
//     retries: 3, // number of retries
//     retryDelay: (retryCount: number) => {
//         console.log(`retry attempt: ${retryCount}`);
//         return retryCount * 2000; // time interval between retries
//     },
//     retryCondition: (error: any) => {
//         // if retry condition is not specified, by default idempotent requests are retried
//         return error.response.status === 500;
//     }
// });
// interceptor for http
axiosServices.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject((error.response && error.response.data) || 'Wrong Services')
);

export default axiosServices;
